import React from 'react';
import { Clock3, RefreshCw } from 'lucide-react';
import './originalsAccessNotice.css';

export const OriginalsAccessNotice = ({ game }) => {
  const access = game.access;
  if (!access?.blocked && !access?.error) return null;
  return <div className="originals-access-notice" role="status" data-testid={`${game.gameType}-access-notice`}>
    <Clock3 size={16} aria-hidden="true" /><p data-testid={`${game.gameType}-access-message`}>{access.error || access.message || (access.until ? `New bets paused until ${new Date(access.until).toLocaleString()}.` : 'New bets paused until an administrator removes the timeout.')}{access.blocked && ' Existing rounds can still be finished.'}</p>
    {access.error && <button type="button" onClick={access.refresh} aria-label="Retry game access check" title="Retry" data-testid={`${game.gameType}-access-retry`}><RefreshCw size={16} /></button>}
  </div>;
};